exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".embedStyle___379sO {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n.contentWrap___2b9Sr .am-list .am-list-body::before {\n  height: 0 !important;\n}\n.contentWrap___2b9Sr .am-list-item {\n  padding-left: 12px;\n}\n.contentWrap___2b9Sr .am-list-item .am-list-line {\n  padding-right: 12px;\n}\n.bgView___yKhTX {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 100vh;\n  width: 100%;\n}\n.loading___4MlAR {\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"embedStyle": "embedStyle___379sO",
	"contentWrap": "contentWrap___2b9Sr",
	"bgView": "bgView___yKhTX",
	"loading": "loading___4MlAR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/routes/author/contract/agreementDetail.less
// module id = 1121
// module chunks = 0